import React, { useEffect, useRef, useState } from "react";
import ErrorMessage from "components/Error";
import Loading from "components/Loading";
import CameraControls from "./CameraControls";

interface PlayerWebRtcProps {
  url: string
}

const PlayerWebRtc: React.FC<PlayerWebRtcProps> = ({ url }) => {
  const [isLoading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const videoRef = useRef<HTMLVideoElement>(null)

  function startPlay() {
    const video = videoRef.current;
    if (!video) return

    const webrtc = new RTCPeerConnection({
      iceServers: [{
        urls: [process.env.REACT_APP_STUN || 'stun:stun.l.google.com:19302']
      }]
    })
    webrtc.ontrack = function (event) {
      console.log(event.streams.length + ' track is delivered')
      video.srcObject = event.streams[0]
      video.play()
    }
    webrtc.addTransceiver('video', { direction: 'sendrecv' })
    webrtc.onnegotiationneeded = async function handleNegotiationNeeded() {
      const offer = await webrtc.createOffer()
      await webrtc.setLocalDescription(offer)

      if (!webrtc.localDescription) {
        return
      }

      fetch(url, {
        method: 'POST',
        body: new URLSearchParams({ data: btoa(webrtc.localDescription.sdp) })
      })
        .then(response => {
          if (response.ok) {
            return response.text()
          } else {
            throw new Error('Wrong response')
          }
        })
        .then(data => {
          try {
            webrtc.setRemoteDescription(
              new RTCSessionDescription({ type: 'answer', sdp: atob(data) })
            )
          } catch (e) {
            console.warn(e)
            setError(true)
          }
        })
        .catch(() => {
          setLoading(false)
          setError(true)
        })
    }

    const webrtcSendChannel = webrtc.createDataChannel('rtsptowebSendChannel')
    webrtcSendChannel.onopen = (event) => {
      console.log(`${webrtcSendChannel.label} has opened`)
      webrtcSendChannel.send('ping')
      setLoading(false)
    }
    webrtcSendChannel.onclose = (_event) => {
      console.log(`${webrtcSendChannel.label} has closed`)
      startPlay()
    }
  }

  useEffect(() => {
    startPlay()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='cam__wrapper'>
      <video
        muted
        autoPlay
        playsInline
        ref={videoRef}
      />
      <CameraControls
        url={url}
        type='webrtc'
      />
      {isLoading && <Loading middleOfPage />}
      {error && <ErrorMessage />}
    </div>
  )
}

export default PlayerWebRtc